/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[wellInputTrim]',
  standalone: true,
})
export class InputTrimDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('blur') onInput() {
    const value = this.el.nativeElement.value;
    const valueTrim = value.trim();
    if (value !== valueTrim) {
      this.el.nativeElement.value = valueTrim;
      this.control.control?.setValue(valueTrim, { onlySelf: true, emitEvent: false });
      this.control.control?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
  }
}
